export default __webpack_public_path__ + "locales/it/Files.json?hash=7ce3db59b1f6c9eeb835d06593019db8";